import asyncComponentLoader from '@/shared/lib/loader';

import { ROUTES } from './paths';
import { PageRoute } from './types';

export const commonRoutes: PageRoute[] = [
  {
    component: asyncComponentLoader(() => import('@/features/shell/pages/LandingPage')),
    path: ROUTES.AUTHORIZED.LANDING,
    title: 'Dashboard',
  },
  {
    component: asyncComponentLoader(() => import('@/features/spaces/pages/LocationPlan')),
    path: `${ROUTES.AUTHORIZED.LOCATION_PLAN}/:id`,
    title: 'Location Plan',
  },
  {
    component: asyncComponentLoader(() => import('@/features/locations/pages/LocationReportsPage')),
    path: `${ROUTES.AUTHORIZED.LOCATION_REPORTS}/:id`,
    title: 'Location Reports',
  },
  {
    component: asyncComponentLoader(() => import('@/features/shell/pages/HelpPage')),
    title: 'Help',
    path: ROUTES.AUTHORIZED.HELP,
  },
  {
    component: asyncComponentLoader(() => import('@/features/assistant/pages/AssistantPage')),
    path: ROUTES.AUTHORIZED.ASSISTANT,
    title: 'Assistant',
  },
  {
    component: asyncComponentLoader(() => import('@/features/spaces/pages/AdvertisingSpacesPage')),
    path: ROUTES.AUTHORIZED.ADVERTISING_SPACES,
    title: 'Advertising Spaces',
  },
  {
    component: asyncComponentLoader(
      () => import('@/features/spaces/pages/AdvertisingSpaceDetailsPage'),
    ),
    path: `${ROUTES.AUTHORIZED.ADVERTISING_SPACES}/:id`,
    title: 'Advertising Space Info',
  },
  {
    component: asyncComponentLoader(() => import('@/features/spaces/pages/SupportPicturesPage')),
    path: `${ROUTES.AUTHORIZED.ADVERTISING_SPACES}/:id/support-pictures`,
    title: 'Space Support Pictures',
    fullScreen: true,
  },
  {
    component: asyncComponentLoader(
      () => import('@/features/packages/pages/AdvertisingPackageSupportPicturesPage'),
    ),
    path: `${ROUTES.AUTHORIZED.ADVERTISING_PACKAGES}/:id/support-pictures`,
    title: 'Package Support Pictures',
    fullScreen: true,
  },
  {
    component: asyncComponentLoader(() => import('@/features/company/pages/CompanyProfilePage')),
    path: `${ROUTES.AUTHORIZED.COMPANY_PROFILE}/:tab?`,
    title: 'Company',
  },
  {
    component: asyncComponentLoader(() => import('@/features/locations/pages/LocationsPage')),
    path: ROUTES.AUTHORIZED.COMPANY_LOCATIONS,
    title: 'Company Locations',
  },
  {
    component: asyncComponentLoader(() => import('@/features/company/pages/CompanyFormPage')),
    path: `${ROUTES.AUTHORIZED.COMPANY_FORM}/:id?`,
    title: 'Company',
  },
  {
    component: asyncComponentLoader(
      () => import('@/features/company/pages/CompanyTeamMemberFormPage'),
    ),
    path: `${ROUTES.AUTHORIZED.COMPANY_TEAM_MEMBER_FORM}/:id?`,
    title: 'Team Member',
  },
  {
    component: asyncComponentLoader(
      () => import('@/features/company/pages/CompanyTeamMemberRemovePage'),
    ),
    path: `${ROUTES.AUTHORIZED.DELETE_COMPANY_TEAM_MEMBER}/:id?`,
    title: 'Remove Team Member',
  },
  {
    component: asyncComponentLoader(
      () => import('@/features/company/pages/CompanyClientRemovePage'),
    ),
    path: `${ROUTES.AUTHORIZED.DELETE_COMPANY_CLIENT}/:id?`,
    title: 'Remove Client',
  },
  {
    component: asyncComponentLoader(
      () => import('@/features/company/pages/CompanyTeamMemberFormSuccessPage'),
    ),
    path: ROUTES.AUTHORIZED.INVITE_SUCCESSFUL,
    title: 'Team Member',
  },
  {
    component: asyncComponentLoader(() => import('@/features/users/pages/UserProfilePage')),
    path: `${ROUTES.AUTHORIZED.USER_PROFILE}/:tab?`,
    title: 'Account Settings',
  },
  {
    component: asyncComponentLoader(() => import('@/features/users/pages/UserProfileFormPage')),
    path: `${ROUTES.AUTHORIZED.PROFILE_FORM}/:id?`,
    title: 'Account Settings',
  },
  {
    component: asyncComponentLoader(() => import('@/features/locations/pages/LocationFormPage')),
    path: `${ROUTES.AUTHORIZED.COMPANY_LOCATION_FORM}/:id?`,
    title: 'Company Location Form',
  },
  {
    component: asyncComponentLoader(() => import('@/features/company/pages/CompanyClientFormPage')),
    path: `${ROUTES.AUTHORIZED.COMPANY_CLIENT_FORM}/org/:advertiserOrgId`,
    title: 'Company Client Form',
  },
  {
    component: asyncComponentLoader(() => import('@/features/company/pages/CompanyClientFormPage')),
    path: `${ROUTES.AUTHORIZED.COMPANY_CLIENT_FORM}/:id?`,
    title: 'Company Client Form',
  },
  {
    component: asyncComponentLoader(() => import('@/features/shell/pages/CalendarPage')),
    path: ROUTES.AUTHORIZED.CALENDAR,
    title: 'Calendar',
  },
  {
    component: asyncComponentLoader(() => import('@/features/orders/pages/OrderPage/OrderCancel')),
    path: `${ROUTES.AUTHORIZED.DELETE_ORDER}/:id`,
    title: 'Cancel Order',
  },
  {
    component: asyncComponentLoader(() => import('@/features/orders/pages/OrderPage/OrderReject')),
    path: `${ROUTES.AUTHORIZED.REJECT_ORDER}/:id`,
    title: 'Reject Order',
  },
  {
    component: asyncComponentLoader(
      () =>
        import('@/features/packages/pages/AdvertisingPackageListPage/AdvertisingPackageListPage'),
    ),
    path: ROUTES.AUTHORIZED.ADVERTISING_PACKAGES,
    title: 'Advertising Packages List',
  },
  {
    component: asyncComponentLoader(
      () =>
        import(
          '@/features/packages/pages/AdvertisingPackageDetailsPage/AdvertisingPackageDetailsPage'
        ),
    ),
    path: `${ROUTES.AUTHORIZED.ADVERTISING_PACKAGES}/:id`,
    title: 'Advertising Package Details',
  },
  {
    component: asyncComponentLoader(() => import('@/features/shell/pages/GeneratikTableDemoPage')),
    path: ROUTES.AUTHORIZED.GENERATIK_TABLE_DEMO,
    title: 'GeneratikTable Demo',
  },
  {
    component: asyncComponentLoader(
      () => import('@/features/orders/pages/GeneratikOrdersDemoPage'),
    ),
    path: ROUTES.AUTHORIZED.GENERATIK_ORDERS_DEMO,
    title: 'GeneratikTable Orders Demo',
  },
];
